import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const FoodAndDining = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Food and Dining
      </Typography>

      <Typography gutterBottom>
        Snacks provided will be healthy, and take any known dietary conditions
        into consideration.
      </Typography>

      <Typography>
        A packed lunch should be provided with your children when dropping them
        off.
      </Typography>
    </Box>
  );
};

export default FoodAndDining;
